











































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class NotFoundComponent extends Vue {
    goBack() {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
}
